var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入名称查询" },
                                    model: {
                                      value: _vm.queryParam.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "name", $$v)
                                      },
                                      expression: "queryParam.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { type: "primary" },
                                      on: { click: _vm.writeCode },
                                    },
                                    [_vm._v("填写插件激活码")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { type: "primary" },
                                      on: { click: _vm.writeAppCode },
                                    },
                                    [_vm._v("填写手机端激活码")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _c(
                    "a-upload",
                    {
                      attrs: {
                        name: "file",
                        showUploadList: false,
                        multiple: false,
                        headers: _vm.tokenHeader,
                        action: _vm.importUrl,
                      },
                      on: { change: _vm.handleImportJar },
                    },
                    [
                      _c(
                        "a-popover",
                        { attrs: { title: "导入注意点" } },
                        [
                          _c("template", { slot: "content" }, [
                            _c("p", [_vm._v("请选择需要导入的插件jar包")]),
                          ]),
                          _c(
                            "a-button",
                            { attrs: { type: "primary", icon: "import" } },
                            [_vm._v("上传插件包")]
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadTemplate(record)
                                    },
                                  },
                                },
                                [_vm._v("上传页面")]
                              ),
                              _c("a-divider", { attrs: { type: "vertical" } }),
                              _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定要开启该插件吗?" },
                                  on: {
                                    confirm: () =>
                                      _vm.startPlugin(
                                        record.pluginDescriptor.pluginId
                                      ),
                                  },
                                },
                                [_c("a", [_vm._v("开启")])]
                              ),
                              _c("a-divider", { attrs: { type: "vertical" } }),
                              _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定要停止该插件吗?" },
                                  on: {
                                    confirm: () =>
                                      _vm.stopPlugin(
                                        record.pluginDescriptor.pluginId
                                      ),
                                  },
                                },
                                [_c("a", [_vm._v("停止")])]
                              ),
                              _c("a-divider", { attrs: { type: "vertical" } }),
                              _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确定要卸载该插件吗?" },
                                  on: {
                                    confirm: () =>
                                      _vm.uninstallPlugin(
                                        record.pluginDescriptor.pluginId
                                      ),
                                  },
                                },
                                [_c("a", [_vm._v("卸载")])]
                              ),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "linkInfo",
                        fn: function (text, record) {
                          return _c("span", {}, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.linkUrl(record),
                                  target: "_blank",
                                  title: _vm.linkUrl(record),
                                },
                              },
                              [_vm._v(_vm._s(_vm.linkUrl(record)))]
                            ),
                          ])
                        },
                      },
                      {
                        key: "customRenderFlag",
                        fn: function (pluginState) {
                          return [
                            pluginState == "STARTED"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("启用"),
                                ])
                              : _vm._e(),
                            pluginState == "STOPPED"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("停止"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("plugin-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk },
              }),
              _c("plugin-app-modal", {
                ref: "appModalForm",
                on: { ok: _vm.appModalFormOk },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }